const mapsURI = 'https://maps.googleapis.com/maps/api';
const stubs = '/themes/custom/cactus/static/json';
const imageUri = '/themes/custom/cactus/static/images';
